// AI Playbooks (learned + hand-authored diagnostic recipes) — React Admin resource strings.
export const aiPlaybooks = {
  name: 'Playbook |||| Playbooks',
  fields: {
    id: 'ID',
    name: 'Name',
    description: 'Description',
    symptomKeywords: 'Symptom Keywords',
    symptomExamples: 'Symptom Examples',
    keyword: 'Keyword',
    example: 'Example',
    triggerConditions: 'Trigger Conditions (JSON)',
    diagnosticSteps: 'Diagnostic Steps (JSON)',
    rootCauseCategory: 'Root Cause Category',
    remediationGuidance: 'Remediation Guidance',
    isActive: 'Active',
    source: 'Source',
    learned: 'Learned',
    manual: 'Manual',
    createdFromInvestigationId: 'Source Investigation',
    createdBy: 'Created By',
    createdAt: 'Created',
    updatedAt: 'Updated',
  },
  sections: {
    identity: 'Identity',
    symptoms: 'Symptoms',
    remediation: 'Remediation',
    diagnostics: 'Diagnostics',
  },
  categories: {
    none: '(none)',
    software_bug: 'Software bug',
    hardware_fault: 'Hardware fault',
    firmware_issue: 'Firmware issue',
    config: 'Configuration',
    user_error: 'User error',
    network: 'Network',
    unknown: 'Unknown',
  },
  filters: {
    isActive: 'Status',
    active: 'Active',
    inactive: 'Inactive',
  },
  list: {
    title: 'Playbooks',
  },
  create: {
    title: 'Create Playbook',
    subtitle: 'Hand-author a diagnostic playbook',
    backToList: 'Back to playbooks',
  },
  edit: {
    title: 'Edit Playbook',
    subtitle: 'Refine this diagnostic playbook',
    backToList: 'Back to playbooks',
  },
  show: {
    emptyJson: 'None',
    emptyArray: 'None',
    manualOrigin: 'Manually authored (no source investigation)',
  },
  helpers: {
    rootCauseCategory: 'Optional. Leave empty if the category is not yet known.',
    isActive: 'Active playbooks are matched against new investigations.',
    symptomKeywords: 'Keywords used to match a symptom to this playbook. At least one is required.',
    symptomExamples: 'Example symptom phrasings used for model-assisted matching.',
    remediationGuidance: 'Human-facing guidance on how to resolve this issue.',
    diagnosticSteps:
      'Ordered JSON array of steps. Each step needs tool, params_template, check, and on_match.',
    triggerConditions: 'Optional JSON object of structured preconditions.',
  },
  errors: {
    invalidJson: 'Invalid JSON. Please fix the syntax before saving.',
  },
  promote: {
    button: 'Promote to playbook',
    success: 'Investigation promoted. Refine the new playbook below.',
    error: 'Could not promote this investigation to a playbook.',
    errorNotFound: 'That investigation no longer exists or is outside your scope.',
    errorNotPromotable: 'This investigation cannot be promoted (already promoted or not completed).',
    errorPermission: 'You do not have permission to promote investigations.',
    disabledRefused: 'A declined investigation cannot be promoted.',
    disabledFailed: 'A failed investigation cannot be promoted.',
    disabledRunning: 'Wait for the investigation to complete before promoting.',
    disabledGeneric: 'Only a completed investigation can be promoted.',
  },
  notifications: {
    created: 'Playbook created successfully.',
    updated: 'Playbook updated successfully.',
    deleted: 'Playbook deleted successfully.',
    error: {
      create: 'Failed to create playbook.',
      update: 'Failed to update playbook.',
      delete: 'Failed to delete playbook.',
    },
  },
};
